import { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSalesContext } from "../Pages/SalesContext";
import SalesTrendHeader from "../Pages/SalesTrendHeader";
import { jwtDecode } from "jwt-decode";
import React from "react";
import CustomerCoverageData from '../CustomerCoverage/Components/CustomerCoverageData';
import { API_BASE_URL } from "../config/config"; // Adjust the import path as necessary
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../utils/dashboardUtils.js";


interface DecodedToken {
  name: string;
  preferred_username: string;
  user_id?: any;
}

interface DecodedToken {
  name: string;
  preferred_username: string;
  user_id?: any;
}

const CoverageDashboard: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setKpiData } = useSalesContext();

  const [refreshTime, setRefreshTime] = useState<string | null>(null);
  const [userLocation, setUserLocation] = useState<string | null>(null);
  const [headerUsername, setHeaderUsername] = useState<string | null>(null);
  const [userData, setUserData] = useState<any>(null);

  // ✅ Handle token from query
  useTokenFromQuery("/app/customercoverage_dashboard");

  // ✅ Reset refresh time
  useResetRefreshTime(setRefreshTime);

  const token = localStorage.getItem("access_token");
  const user_id = getUserIdFromToken();

  // ✅ Memoized Callbacks — prevents multiple re-renders from triggering the effect
  const handleLocation = useCallback((loc: string) => {
    setUserLocation(loc);
  }, []);

  const handleName = useCallback((name: string) => {
    setHeaderUsername(name);
  }, []);

  const handleTime = useCallback((time: string) => {
    setRefreshTime(time);
  }, []);

  const handleRawData = useCallback(
    (rawData: any) => {
      if (!token) return;
      const decoded: DecodedToken = jwtDecode(token);
      const preferredUserId = decoded?.preferred_username || "";
      setUserData({ ...rawData, userId: preferredUserId });
      setKpiData?.(rawData);
    },
    [token, setKpiData]
  );

  // ✅ Fetch user details only once
  useFetchUserDetails(
    handleLocation,
    handleName,
    handleTime,
    API_BASE_URL,
    "CustomerCoverageDashboard",
    handleRawData
  );

  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="Customer coverage analysis"
          userName={headerUsername}
          location={userLocation}
          refreshTime={refreshTime}
        />
        <CustomerCoverageData user_id={user_id} user_data={userData} />
      </div>
    </div>
  );
};

export default CoverageDashboard;



